export function BZCRichLinkAManoBoxConstructor(services) {

  const joint = services.joint;
  return joint.shapes.html.AbstractBoxWithInPort.extend({
    defaults: joint.util.deepSupplement({
      'labelText': services.$translate.instant('parameters/quick_replies/details/graph/rich_link_a_mano_box_title_in_diagram'),
      'labelFill': '#3977e4',
      'type': 'html.BZCRichLinkAManoBox'
    }, joint.shapes.html.AbstractBoxWithInPort.prototype.defaults)
  });

}
